// extracted by mini-css-extract-plugin
export default {"Badge":"EogltZbbg1UVfKBKUJK5","ActiveBadge":"L6eIbriZS3WXGAwuI_ad"};